"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDates = exports.getDiffDays = void 0;
var _react = require("react");
var todayMilis = 1000 * 60 * 60 * 24;
var useDates = exports.useDates = function useDates() {
  var maskStartDate = (0, _react.useCallback)(function (date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }, []);
  var maskEndDate = (0, _react.useCallback)(function (date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
  }, []);
  var data = (0, _react.useMemo)(function () {
    var today = maskStartDate(new Date());
    var yesterday = maskStartDate(new Date(today.getTime() - todayMilis));
    var thisMonthStart = maskStartDate(new Date(today.getFullYear(), today.getMonth(), 1));
    var thisMonthEnd = maskStartDate(new Date(new Date(today.getFullYear(), today.getMonth() + 1, 1).getTime() - todayMilis));
    var lastMonthStart = maskStartDate(new Date(today.getFullYear(), today.getMonth() - 1, 1));
    var lastMonthEnd = maskStartDate(new Date(new Date(today.getFullYear(), today.getMonth(), 1).getTime() - todayMilis));
    var thisWeekStart = maskStartDate(new Date(new Date().setDate(today.getDate() - today.getDay() + (today.getDay() === 0 ? -7 : 1))));
    var thisWeekEnd = maskStartDate(new Date(thisWeekStart.getTime() + todayMilis * 6));
    var lastWeekStart = maskStartDate(new Date(thisWeekStart.getTime() - todayMilis * 7));
    var lastWeekEnd = maskStartDate(new Date(lastWeekStart.getTime() + todayMilis * 6));
    return {
      today: today,
      yesterday: yesterday,
      thisMonthStart: thisMonthStart,
      thisMonthEnd: thisMonthEnd,
      lastMonthStart: lastMonthStart,
      lastMonthEnd: lastMonthEnd,
      thisWeekStart: thisWeekStart,
      thisWeekEnd: thisWeekEnd,
      lastWeekStart: lastWeekStart,
      lastWeekEnd: lastWeekEnd
    };
  }, [maskStartDate]);
  return [data, maskStartDate, maskEndDate];
};
var getDiffDays = exports.getDiffDays = function getDiffDays(from, to) {
  if (!from || !to) return;
  var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  var firstDate = from.getTime();
  var secondDate = to.getTime();
  return Math.round(Math.abs((firstDate - secondDate) / oneDay));
};